import { RemoteUpdateStatusAssociatePersonProfile } from 'data/usecases';
import { makeProfilesAssociated } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateStatusAssociatePersonProfile =
  (): RemoteUpdateStatusAssociatePersonProfile => {
    return new RemoteUpdateStatusAssociatePersonProfile(
      makeProfilesAssociated(),
      makeAxiosHttpClient(),
    );
  };
